import { render, staticRenderFns } from "./Borrowed.vue?vue&type=template&id=715a3160&"
import script from "./Borrowed.vue?vue&type=script&lang=js&"
export * from "./Borrowed.vue?vue&type=script&lang=js&"
import style0 from "./Borrowed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
